/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/userListsWithBoxes.config.json";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import {
  GET_MY_COMMITTE_INVITE_STATUS,
  GET_MY_PROFILE,
  GET_PRESENTATIONS,
  GET_USERS_WITH_BOXES,
  GET_USERS_WITH_BOXES_COMMITTEE,
} from "../graphql";
import { VApplication } from "../../../application";
import moment from "moment-timezone";
import { pretty } from "@vlinder-web/utils-react";
import { AppNavigatorService } from "../../appNavigatorService";
import { eq } from "lodash";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};
const getAppNavService = () => {
  const app = VApplication.getInstance();
  return app?.getSync("services.AppNavigatorService") as AppNavigatorService;
};
export interface IUserListsWithBoxesMethods extends IPluginMethodMap {
  getUserListsWithBoxesProps(args: any): Promise<any>;
}

export class UserListsWithBoxesService implements IAgentPlugin {
  readonly methods: IUserListsWithBoxesMethods;

  constructor() {
    this.methods = {
      getUserListsWithBoxesProps: this.getUserListsWithBoxesProps.bind(this),
    };
  }

  async getUserListsWithBoxesProps(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    let filter = {};
    console.log("args?.criteria?.role==>", args);
    let searchType = this.determineSearchType(args?.criteria);
    console.log("whereCls search==>", searchType);
    if (searchType && searchType !== null) {
      if (searchType === "multi") {
        filter = this.getMultiFilter(args?.criteria?.data);
      } else {
        filter = this.convertCriteria(args?.criteria?.data);
      }
    }
    try {
      if (client) {
        const _res = await client.query({
          query: GET_MY_PROFILE,
          fetchPolicy: "network-only",
        });
        console.log("_res==>", _res);
        let comm_pre_id: any = "",
          presentationOptions: any = [],
          defaultPresentation: any = "";

        if (_res?.data?.getMyProfile?.role[0]?.name === "committeeMember") {
          const comm_presentation = await client.query({
            query: GET_MY_COMMITTE_INVITE_STATUS,
            fetchPolicy: "network-only",
          });
          if (
            comm_presentation?.data?.getMyCommitteInviteStatus?.content[0]
              ?.presentation?.id
          ) {
            defaultPresentation =
              comm_presentation?.data?.getMyCommitteInviteStatus?.content[0]
                ?.presentation?.id;
          } else {
            throw new Error("No invites !!");
          }
        }

        // if (_res?.data?.getMyProfile?.role[0]?.name !== 'committeeMember') {
        const presentation = await client.query({
          query: GET_PRESENTATIONS,
          variables: {
            options: {
              limit: 0,
              skip: 0,
              sort: {
                field: "status",
                order: "asc",
              },
            },
          },
          fetchPolicy: "network-only",
        });
        const activeItem = presentation?.data?.getPresentations?.content.find(
          (item: any) => item.status === "active"
        );
        defaultPresentation = args?.criteria?.presentation
          ? args?.criteria?.presentation
          : activeItem && activeItem?.id
          ? activeItem?.id
          : null;

        // defaultPresentation =
        //   presentation?.data?.getPresentations?.content[0]?.id;
        presentationOptions =
          presentation?.data?.getPresentations?.content?.map((_item: any) => {
            return { value: _item?.id, label: _item?.name, year: _item?.year };
          });
        // }
        console.log(
          "presenttion chck",
          presentation,
          args?.criteria?.presentation,
          defaultPresentation
        );
        const checkPresentation =
          args?.criteria?.presentation ?? defaultPresentation;
        if (!checkPresentation) {
          throw new Error("No Active Presentations");
        }
        let role = _res?.data?.getMyProfile?.role[0]?.name;
        console.log("myrole", role);
        const res = await client.query({
          query:
            role == "committeeMember"
              ? GET_USERS_WITH_BOXES_COMMITTEE
              : GET_USERS_WITH_BOXES,
          variables: {
            // presentationId: defaultPresentation,
            // invitedByUser: _res?.data?.getMyProfile?.fullName,
            filters: {
              InviteBy___email: {
                eq: _res?.data?.getMyProfile?.email,
              },
              presentation: {
                eq: defaultPresentation,
              },
              ...filter,
            },
            options: {
              limit: args?.size ?? 10,
              skip: args?.offset ?? 0,
              sort: {
                field: "createdAt",
                order: "desc",
              },
            },
          },
          fetchPolicy: "network-only",
        });
        let emailOptions: any[] = [];
        if (res?.data) {
          emailOptions = res?.data?.getReferals?.content.map((user: any) => ({
            label: user?.user?.firstName
              ? `${user?.user?.firstName}(${user?.user?.email})`
              : user?.user?.email,
            value: user?.user?.email,
          }));
          console.log(res?.data?.getReferals?.content);
        }

        if (res?.data) {
          console.log(
            "id====>",
            args?.criteria?.presentation,
            "default==>",
            defaultPresentation
          );
          let _rowData = this.formatUserTable(
            res?.data?.getReferals?.content,
            role
          );

          let _totalPages = res?.data?.getReferals?.count
            ? parseInt(res?.data?.getReferals?.count) / 10
            : 1;

          let _currentPage =
            res?.data?.getReferals?.skip / res?.data?.getReferals?.limit + 1;

          return {
            ...config,
            ultUsers: _rowData,
            isEmpty: res?.data?.getReferals?.data?.length <= 0,
            activePage: _currentPage,
            currentPage: _currentPage,
            pageSize: _rowData.length,
            totalCount: res?.data?.getReferals?.count,
            totalPages: _totalPages,
            emailOptions: emailOptions,
            searchPresentationFilter: presentationOptions,
            presentation: defaultPresentation,
            defaultPresentation: checkPresentation,
            email: _res?.data?.getMyProfile?.email,
            role: role,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
  private determineSearchType(criteria: any) {
    if (Object.keys(criteria).length === 0) {
      return null;
    } else if (Object.keys(criteria?.data)[0] === "0") {
      return "multi";
    } else {
      return "normal";
    }
  }

  private convertCriteria(criteria: any) {
    const result: any = {};
    for (const key in criteria) {
      // Skip the 'presentation' key
      if (
        key === "presentation" ||
        (key === "User___inviteStatus" && criteria[key] === "all")
      ) {
        continue;
      } else {
        result[key] = { contains: criteria[key] };
      }
    }
    console.log(`result---->`, result);
    return result;
  }

  private getMultiFilter(criteria: any) {
    const transformedCriteria: any = {};
    for (const key in criteria) {
      if (criteria.hasOwnProperty(key)) {
        const { key: filterKey, filters } = criteria[key];
        const { inputData } = filters;
        const filterType = Object.keys(filters).find(
          (key) => key !== "inputData"
        );

        const filterValue = filters[filterType];

        // if (inputData.id === "Boxes___boxStatus") {
        //   // If the id is "Boxes___boxStatus", assign the value directly
        //   transformedCriteria[inputData.id] = filterValue;
        // } else {
        // Convert "true" and "false" strings to actual boolean values
        if (
          typeof filterValue === "string" &&
          filterValue.toLowerCase() === "true"
        ) {
          transformedCriteria[inputData.id] = {
            [filterType.toLowerCase().replace("equal", "eq")]: true,
          };
        } else if (
          typeof filterValue === "string" &&
          filterValue.toLowerCase() === "false"
        ) {
          transformedCriteria[inputData.id] = {
            [filterType.toLowerCase().replace("equal", "eq")]: false,
          };
        } else {
          transformedCriteria[inputData.id] = {
            [filterType.toLowerCase().replace("equal", "eq")]: filterValue,
          };
        }
      }
    }
    // }
    return transformedCriteria;
  }

  private formatUserTable(data: any, role: any) {
    const RECENT_INVITE_MS = 24 * 60 * 60 * 1000;
    const now = Date.now();
    let _rowData: any = [];
    Array.isArray(data) &&
      data.forEach((item: any) => {
        console.log("res?.data==>", pretty(item));
        const createdAtRaw = item?.createdAt ?? null;
        _rowData.push({
          myrole: role,
          id: item?.user?.id,
          vuid: item?.user?.vuid,
          rid: item?.id,
          boxStatus: item?.box?.boxStatus
            ? this.getBoxStatus(item?.box?.boxStatus)
            : "Not Purchased",
          section: item?.sections?.name ?? "-",
          sectionId: item?.sections?.id ?? "-",
          sectionOptType: item?.sectionOptType ?? "-",
          partition:
            item?.partition ??
            // item?.Boxes[0]?.Referal?.partition ??
            "-",
          inviteStatus: item?.inviteStatus ?? "-",
          inviteType: item?.inviteType ?? "-",
          amountPaid: item?.box?.amountPaid
            ? item?.box?.amountPaid.toFixed(2)
            : 0,
          note: item?.box?.note ?? "-",
          discountAmount: item?.box?.discount?.discountAmount ?? 0,
          totalAmount: item?.box?.totalAmount
            ? item?.box?.totalAmount.toFixed(2)
            : 0,
          paymentStatus: item?.box?.paymentStats ?? "-",
          userStatus: this.getFormattedStatus(
            item?.user?.accountStatus,
            item?.user?.suspended
          ),
          presentationName: item?.presentation?.name ?? "",
          presentationId: item?.presentation?.id ?? "",
          name: `${item?.user?.firstName ?? ""} ${item?.user?.lastName ?? ""}`,
          email: item?.user?.email ?? "",
          gender: item?.user?.gender ?? "-",
          verified: item?.user?.emailVerified,
          role: this._getRole(item?.user?.role),
          inviteNote: item?.inviteNote ?? "-",
          createdAt: createdAtRaw
            ? this.formatCreatedDate(createdAtRaw)
            : " ",
          createdAtRaw,
          isRecentlyCreated: createdAtRaw
            ? now - new Date(createdAtRaw).getTime() <= RECENT_INVITE_MS
            : false,
          expiresOn: item?.expiresOn,
          discountCode:
            item?.discountCodeBox?.discountCode ??
            item?.discountCode?.discountCode ??
            "-",
          discountId:
            item?.discountCodeBox?.discountId ??
            item?.discountCode?.discountId ??
            "-",
          discountStatus:
            item?.discountCodeBox?.status ??
            item?.discountCode?.status ??
            "Not Applicable",
        });
      });
    return _rowData;
  }

  private getBoxStatus(boxStatus: string) {
    if (boxStatus) {
      if (boxStatus == "PartialPurchased") {
        return "Partially Paid";
      } else if (boxStatus == "Purchased") {
        return "Paid";
      }
      return boxStatus;
    }
  }

  private _getRole(roles: any[]) {
    let _res: any[] = [];
    roles &&
      Array.isArray(roles) &&
      roles.length > 0 &&
      roles.map((item: any, index: number) => {
        _res.push(item?.name);
      });
    return _res;
  }

  private formatCreatedDate(date: Date) {
    if (date) {
      return moment(date).format("LL");
    }
  }

  private getFormattedStatus(status: string, suspended: boolean) {
    if (suspended) {
      return "suspended";
    } else {
      switch (status) {
        case "USER_ADDED":
          return "Imported";
        case "USER_INVITED":
          return "Invited";
        case "USER_VERIFIED":
          return "Registered";
        case "USER_ACC_CREATED":
          return "Registered";
        case "SUSPENDED":
          return "Suspended";
        default:
          return "-";
      }
    }
  }

  private getFilter(criteria: any) {
    if (criteria?.firstName) {
      return {
        column: "firstName",
        op: "Contains",
        value: criteria?.firstName.toLowerCase(),
      };
    }
    if (criteria?.email) {
      return {
        column: "email",
        op: "Contains",
        value: criteria?.email.toLowerCase(),
      };
    }
    return null;
  }
}
